// Runs at module-import time, BEFORE React mounts. Imported as the first line
// of src/main.tsx so gtag defaults are declared before any tracker has a chance
// to load. Keep side effects here minimal and synchronous.

import { readConsent } from './consent-storage';
import { categoriesToGtagParams } from './consent-activator';

if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'granted',
    wait_for_update: 500,
  });

  const existing = readConsent();
  if (existing) {
    window.gtag('consent', 'update', categoriesToGtagParams(existing.categories));
  }
}
